import { LOCALE } from 'utils/constants';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { kkTranslations } from 'utils/kkTranslations';
import { ruTranslations } from 'utils/ruTranslations';
import { enTranslations } from 'utils/enTranslations';

i18n.use(initReactI18next).init({
	returnNull: false,
	resources: {
		ru: { translation: ruTranslations },
		kk: { translation: kkTranslations },
		en: { translation: enTranslations }
	},
	lng: localStorage.getItem(LOCALE) ?? 'ru',
	fallbackLng: 'ru',
	interpolation: {
		escapeValue: false
	}
});

export default i18n;
